import { NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import {
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAngleDown,
	faCheckSquare,
	faExclamationTriangle,
	faExclamation,
	faBuilding,
	faPlus,
	faComment,
	faChartPie,
	faStar,
	faCogs,
	faClock,
	faEnvelope,
	faTasks,
	faFile,
	faFileExcel,
	faFilePdf,
	faFileWord,
	faArrowLeft,
	faArrowRight,
	faCommentAlt,
	faPhone,
	faMapMarker,
	faTimes,
	faPercentage,
	faUser,
	faUserPlus,
	faPencilAlt,
	faTrashAlt,
	faLock,
	faDownload,
	faMinus,
	faBolt,
	faCheck,
	faUserTag,
	faUserClock,
	faExclamationCircle,
	faCircleNotch,
	faEye,
	faEyeSlash,
	faInfo,
	faReply
} from '@fortawesome/free-solid-svg-icons';

import {
	faCommentAlt as farCommentAlt
} from '@fortawesome/free-regular-svg-icons';

@NgModule({
	exports: [
		FontAwesomeModule
	]
})
export class IconModule {

	constructor(private library: FaIconLibrary) {
		library.addIcons(
			faAngleLeft,
			faAngleRight,
			faAngleUp,
			faAngleDown,
			faArrowLeft,
			faArrowRight,
			faBuilding,
			faCheckSquare,
			faComment,
			faChartPie,
			faCommentAlt,
			faExclamationTriangle,
			faExclamation,
			faExclamationCircle,
			faMapMarker,
			faPercentage,
			faPhone,
			faPlus,
			faStar,
			faCogs,
			faClock,
			faEnvelope,
			faTasks,
			faTimes,
			faUser,
			faUserPlus,
			farCommentAlt,
			faPencilAlt,
			faTrashAlt,
			faLock,
			faDownload,
			faMinus,
			faBolt,
			faCheck,
			faUserTag,
			faUserClock,
			faCircleNotch,
			faEye,
			faEyeSlash,
			faInfo,
			faReply
		);
	}
}